import { ITreeNode, Tree } from '@blueprintjs/core'
import { LocationTreeNodeT } from './forEachNode'

const forEachParent = (
  nodePath: number[],
  forEachParentCallback: (node: ITreeNode, isSavedTreeNodeList?: boolean) => void,
  clonedLocationTreeNodes: LocationTreeNodeT[],
  isSavedTreeNodeList?: boolean
) => {
  const parentNodePath = [...nodePath].slice(0, nodePath.length)

  parentNodePath.forEach((_, i) => {
    forEachParentCallback(
      Tree.nodeFromPath(parentNodePath.slice(0, nodePath.length - i), clonedLocationTreeNodes),
      isSavedTreeNodeList
    )
  })
}

export default forEachParent
